// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartLinesStyles } from "@guestsupply/App/Components/Cart/CartLinesHeader";
import InfoAlert from "@guestsupply/XDL/Icons/InfoAlert";
import { createLinkIconStyles, xScreen } from "@guestsupply/XDL/Utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

cartLinesStyles.headerWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        padding-top: 20px;
        border-top: ${({ isOrderConfirmationPage }: any) => (isOrderConfirmationPage ? "0" : "1px")} solid
            ${getColor("common.border")};
        margin-bottom: 12px;
        ${xScreen("lte", "sm")} {
            flex-direction: column;
            padding-top: 16px;
        }
    `,
};
cartLinesStyles.freeShippingLink = {
    ...createLinkIconStyles(InfoAlert, {
        typographyProps: {
            size: 12,
            weight: "bold",
            css: css`
                margin-left: 2px;
                line-height: 12px;
            `,
        },
        icon: {
            iconProps: {
                size: 12,
                color: "text.link",
            },
            position: "right",
        },
        css: css`
            &&& {
                display: flex;
            }
        `,
    }),
};
cartLinesStyles.orderLinesTypography = {
    as: "p",
    css: css`
        margin: 0;
    `,
};
cartLinesStyles.tooltipStyle = {
    cssOverrides: {
        tooltipClickable: css`
            margin-left: 0;
        `,
    },
};
cartLinesStyles.lineHeaderStyle = {
    wrapper: {
        css: css`
            margin-top: 6px;
        `,
    },
};
